<template>
  <div class="mb-5 mt-4 flex justify-center">
    <img
      src="@/assets/edge-capacity.svg"
      alt="edge capacity logo"
    />
  </div>
  <div class="my-4 mb-8 w-full border-t border-light-gray md:border-none" />
  <layout>
    <h3 class="mb-6 text-left text-3xl text-dark-gray">Sign in with Highway</h3>
    <p class="my-5 text-left text-dark-gray">
      Click below to sign in with Highway!
    </p>

    <!-- <button-main
        class="my-3 mb-4"
        type="submit"
        value="Login with Highway"
      >
      </button-main> -->
    <div class="mb-3">
      <router-link
        to="/oauth/authorizations?response_type=code&client_id=3542d087-57d8-44a8-aefb-c581b8e86a08&scope=capacity%2Conboarding%2Ctendering%2Ctracing&redirect_uri=https%3A%2F%2Fstaging-highway-login-screens.s3.amazonaws.com%2Fportals%2Farrive.html"
        class="mx-auto inline-block w-max rounded-md bg-yellow-500 p-4 px-8 text-white"
      >
        Login with Highway (Broker A)
      </router-link>
    </div>
    <div class="mb-3">
      <router-link
        to="/oauth/authorizations?response_type=code&client_id=4176b513-7c9d-4fe1-bffc-95a75bc7c4a3&scope=onboarding%2Ctendering%2Ctracing&redirect_uri=https%3A%2F%2Fcapacity-qa.edgelogistics.com%2Flogin"
        class="mx-auto inline-block w-max rounded-md bg-yellow-500 p-4 px-8 text-white"
      >
        Login with Highway (Broker B)
      </router-link>
    </div>
    <div class="mb-3">
      <router-link
        to="/oauth/authorizations?response_type=code&client_id=397290b5-e9b2-436a-9189-3b25e2f84a37&scope=capacity%2Conboarding%2Ctendering%2Ctracing&redirect_uri=https%3A%2F%2Fstaging-highway-login-screens.s3.amazonaws.com%2Fportals%2Fedge.html"
        class="mx-auto inline-block w-max rounded-md bg-yellow-500 p-4 px-8 text-white"
      >
        Login with Highway (Broker C)
      </router-link>
    </div>
    <div class="mb-3">
      <router-link
        to="/oauth/authorizations?response_type=code&client_id=b7c50569-1380-43f0-a6e2-9ecbd0f39fa1&scope=capacity%2Conboarding%2Ctendering%2Ctracing&redirect_uri=https%3A%2F%2Fstaging-highway-login-screens.s3.amazonaws.com%2Fportals%2Fport_city.html"
        class="mx-auto inline-block w-max rounded-md bg-yellow-500 p-4 px-8 text-white"
      >
        Login with Highway (Broker D)
      </router-link>
    </div>
    <div class="mb-3">
      <router-link
        to="/oauth/authorizations?response_type=code&client_id=a2b2b8a7-f543-464a-b28d-703fd3aac7a9&scope=capacity%2Celd_verification%2Conboarding%2Ctendering%2Cmonitoring%2Ctracing%2Cbilling&redirect_uri=https%3A%2F%2Ftrinitylogistics.com%2F"
        class="mx-auto inline-block w-max rounded-md bg-yellow-500 p-4 px-8 text-white"
      >
        Login with Highway (Broker E)
      </router-link>
    </div>
    <div class="mb-3">
      <router-link
        to="/oauth/authorizations?response_type=code&client_id=397290b5-e9b2-436a-9189-3b25e2f84a37&scope=capacity%2Conboarding%2Ctendering%2Ctracing&redirect_uri=https%3A%2F%2Fstaging-highway-login-screens.s3.amazonaws.com%2Fportals%2Fta_services.html"
        class="mx-auto inline-block w-max rounded-md bg-yellow-500 p-4 px-8 text-white"
      >
        Login with Highway (Broker F)
      </router-link>
    </div>
    <div class="mb-3">
      <router-link
        to="/oauth/authorizations?response_type=code&client_id=cd02aa26-ed61-4ce4-8e9a-16247fe899a0&scope=capacity%2Conboarding%2Ctendering%2Ctracing&redirect_uri=https%3A%2F%2Fstaging-highway-login-screens.s3.amazonaws.com%2Fportals%2Fschneider.html"
        class="mx-auto inline-block w-max rounded-md bg-yellow-500 p-4 px-8 text-white"
      >
        Login with Highway (Broker G)
      </router-link>
    </div>
    <div class="mb-3">
      <router-link
        to="/oauth/authorizations?response_type=code&client_id=8501db04-b3ee-43ad-b08c-c280d5427cfe&scope=capacity%2Conboarding%2Ctendering%2Ctracing&redirect_uri=https%3A%2F%2Fstaging-highway-login-screens.s3.amazonaws.com%2Fportals%2Fedge.html"
        class="mx-auto inline-block w-max rounded-md bg-yellow-500 p-4 px-8 text-white"
      >
        Login with Highway (Broker Demo)
      </router-link>
    </div>
  </layout>
</template>

<script>
import Layout from '@/components/LoginLayout.vue';

export default {
  name: 'LoginWithHighway',
  components: {
    Layout,
  },
};
</script>
